export default __webpack_public_path__ + "static/media/content_copy_icon.b7736776.svg";